import React from 'react';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';

const AppLayout = ({ user, onLogout, onNavigate, currentView, children, subView, api }) => {
  return (
    <div className="mainWrap" id="mainWrap">
      {user && (
        <Sidebar onNavigate={onNavigate} currentView={currentView} user={user} subView={subView} />
      )}
      <section className="mainSec">
        {user && (
          <TopNavbar user={user} onNavigate={onNavigate} onLogout={onLogout} api={api}/>
        )}
        <div className="mainContentWrap">
          <div className="mainContent">
            <div className="mainContentCT dBlock">
              {children}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AppLayout;